module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAHvGGIaGhjUkADUcED0YDBQcAFEEBBwQCCQMABQQAD0AADEAAC0AACQAABwAABQABAwAAAQAAP///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEHABIALAAAAAAgACAAAAXAoCSOZGmeaGpGbKS+awTMLgzLc17bKJ7rvBOO9aMFSUSWwgc8tgCsRoNp5LUgtBYVqgqIWo6fdrszBQLaIvTxFKfQbfXY3WMV1OI0tIyMLA54RXp8I3qBeVUrh4uJJUNEjAAMLT06EQICjFIslToOEQgJh1o9EmKfEQkDeKSlpjmTLAQERQpLhEgiRQYtBA85DrEvLnixEVJ7LF7DgQwMEEnKZzeBEdAynE6RuNSjR47V34oAulziK7nnQpTq7SkhADs="


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadSW_S2.gif
// module id = HGnO
// module chunks = 48